var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-small",on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.pret ? _vm.$t('sketchy.page_jeu.player_list.pas_pret') : _vm.$t('sketchy.page_jeu.player_list.pret'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }